import type { IconSvgObject } from './types';

const Forward01Icon: IconSvgObject = [
  ["path", { d: "M9.47814 19.0621C8.81187 19.4721 7.95404 18.9928 7.95404 18.2104V5.78957C7.95404 5.00725 8.81187 4.5279 9.47814 4.93791L19.5701 11.1484C20.2046 11.5388 20.2046 12.4612 19.5701 12.8517L9.47814 19.0621Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3.95404 4.5L3.95404 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Forward01Icon;
